import React from 'react';
import { AppProvider } from './context/AppContext';
import { ConfirmProvider } from './context/ConfirmContext';
import NotificationToast from './components/ui/NotificationToast';
import ModalRenderers from './components/modals/ModalRenderers';
import SurveyModal from './pages/SurveyModal';
import CookieBannerUI from './pages/CookieBannerUI';
import AppRoutes from './routes/AppRoutes';
import AuthNavigationGuard from './routes/AuthNavigationGuard';

const App = () => (
  <AppProvider>
    <ConfirmProvider>
      <AuthNavigationGuard />
      <AppRoutes />
      <ModalRenderers />
      <SurveyModal />
      <CookieBannerUI />
      <NotificationToast />
    </ConfirmProvider>
  </AppProvider>
);

export default App;
